import React from "react";
import { Card, Table, Badge } from "react-bootstrap";
import { BASE_URL, formatarTamanho } from "./utils";

function MaioresArquivosTop15({ topPorTamanho, isGlobal = true }) {
  if (!topPorTamanho || topPorTamanho.length === 0) return null;

  return (
    <Card className="mb-4">
      <Card.Header className="fw-semibold">
        Maiores arquivos — top 15{isGlobal ? " global" : ""}
      </Card.Header>
      <Card.Body className="p-0">
        <Table striped bordered hover responsive size="sm" className="mb-0">
          <thead>
            <tr>
              <th>#</th>
              {isGlobal && <th>Entidade</th>}
              <th>Nome</th>
              <th>Tamanho</th>
              <th>Tipo</th>
              <th>Documento</th>
              <th>Aditivo/Renovação</th>
            </tr>
          </thead>
          <tbody>
            {topPorTamanho.map((a, idx) => (
              <tr key={`top-${a.id_documento}-${a.id_aditivo ?? "doc"}-${idx}`}>
                <td>{idx + 1}</td>
                {isGlobal && (
                  <td><small className="text-muted">{a.nome_entidade || `#${a.id_entidade}`}</small></td>
                )}
                <td>
                  {(a.path || a.arquivo_documento) ? (
                    <a
                      href={`${BASE_URL}/${(a.path || a.arquivo_documento || "").replace(/^\//, "")}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary text-decoration-none"
                      download
                    >
                      {a.nome_real || a.nome_anexo || "—"}
                    </a>
                  ) : (a.nome_real || a.nome_anexo || "—")}
                </td>
                <td>{formatarTamanho(a.tamanho)}</td>
                <td>
                  <Badge bg={a.tipo === "aditivo" ? "info" : "secondary"} text={a.tipo === "aditivo" ? "dark" : undefined}>
                    {a.tipo === "aditivo" ? "Aditivo" : "Documento"}
                  </Badge>
                </td>
                <td>{a.id_documento ?? "—"}</td>
                <td>{a.id_aditivo ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default MaioresArquivosTop15;
